// https://netatmo.atlassian.net/wiki/spaces/ADMIN/pages/1735589919/Support+DGM+rights+v3#Frontend-logic%3A
// detailed explanation of the rights

import { NewRightsMap } from '~/interfaces/rightsMap.interface';
// common contains all actions for given right that are common to all products
// any device type specific action is found in its own category

// "NaCamera", "mainloop", "test"


export const newRightsMap: NewRightsMap = {
    common: {
        gateway_type: {
            read: [
                'dump',
                'dumpLogs',
                'logs',
                'mainloop',
                'ping',
                'timeline',
                'statsDump',
                'statsDumpVerbose',
                'diagnosis',
                'getOwners', // getDeviceOwners
            ],
            setCustomThreshold: ['getThresholds', 'setThresholds'],
            write: [
                'setDeviceGroup', // "modifyGroup",
                'switchDebug', // "updateDevice"
                'orderReboot', // "orderDeviceReboot"
                'recalibrateCO2', // "recalibrateCo2"
                'dissociate', //"dissociateModule"
                'setOffset', //"setDataOffset"
                'setBehavior', // "modifyDeviceBehavior"
                'setDump', // "toggleDeviceDump"
                'sendVpnCommand',
                'setHeatingAlgo', // "changeHeatingAlgo"
                'recomputeHeating', // "recomputeHeatingAlgo"
                'installQRCode', // "generateQrCode"
                'resetQRCode', // "generateQrCode"
                'importData', // "importMigrationData2" && "migrateData2"
                'getPlantInfo', //getPlantInfo
                'getPlantDevices', // "getPlantModules"
                'unlock', // "unlockNetwork"
                'moveToTemporaryHome', // "moveDeviceToNewTemporaryHome"
                'associateUser', // associateUser
                'deleteCache', //"deleteDeviceCache",
            ],
            reset: [
                'reset', // "resetDevice"
                'fullReset',
                'homekitReset',
                'electricalReset',
            ],
            resetMigration: [
                'rollbackMigration', // rollbackMigration
                'resetMigrationFlag', // resetMigrationFlag
            ],
            writeSsh: ['enableSsh'],
            readSecret: ['readSecret'],
            modelDump: ['modelDump'],
            switchDatabase: ['switchDatabase'],
            triggerLogsDump: ['triggerLogsDump'],
            rollbackMigration: ['rollbackMigration'],
            getLocalResources: ['getLocalResources'],
            getOEMInfos: ['getOEMInfos'],
            switchDebug: ['switchDebug'],
            resetFlag: ['resetFlag'],

        },
        topology_type: {
            write: ['removeUser'],
            read: ['readRoom'],
            delete: ['deleteUser'],
        },
        management: {
            // moderator: ['manageModerators'],
            // super_moderator: ['manageModeratorGroups']
        },
        app_type: {
            assign: ['assign'],
            edit: ['edit'],
            create: ['create'],
            delete: ['delete'],
            release: ['release'],
        }
    },
    specific: {
        TopologyEliot: {
            delete: ['deletePlant'],
        },
        TopologyNetatmo: {
            read: ['getMacRangeCsv'],
            readPreferences: ['getUserConsents'],
            writePreferences: ['storeUserConsents'],
            write: ['deleteEmptyHomes'],
            deleteIdentityKeys: ['deleteIdentityKeys'],
        },
        TopologyVelux: {
            write: ['deleteEmptyHomes'],
        },
        TopologyMuller: {
            write: ['deleteEmptyHomes'],
        },
        TopologyMfh: {
            write: ['deleteEmptyHomes'],
        },
        TopologyVaillant: {
            write: ['deleteEmptyHomes'],
        },
        WeatherExtract: {
            read: ['read'],
            write: ['write'],
        },
    },
};

